class Monitoring.NotificationsView extends Backbone.View
  template: JST["backbone/templates/monitoring/notifications"]

  initialize: (@options = {})->
    @count = @options.count

  render: ->
    @$el.html @template
      count: @count

  updateCount: (count) ->
    @count = count
    @render()
